if (!window.customElements.get('product-details-modal')) {
  class ProductDetailsModal extends HTMLElement {
    connectedCallback() {
      this.id = this.getAttribute('data-product-id');
      this.overlay = this.querySelector('[data-product-details-modal-overlay]');
      this.closeButton = this.querySelector('[data-product-details-modal-close]');
      this.addToCartButton = this.querySelector('[data-product-card-add-to-box]');
      const matchingModals = document.querySelectorAll(`product-details-modal[data-product-id="${this.id}"]`);

      if (matchingModals.length >= 2) {
        this.remove();
      } else {
        if (this.overlay) {
          this.overlay.addEventListener('click', () => this.close());
        }

        if (this.closeButton) {
          this.closeButton.addEventListener('click', () => this.close());
        }

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.classList.contains('is-open')) {
            this.close();
          }
        });

        if (this.closest('product-card')) {
          document.body.appendChild(this);
        }

        if (this.addToCartButton) {
          this.addToCartButton.addEventListener('click', () => this.close());
        }

        document.addEventListener('openProductDetailsModal', (event) => {
          if (event.detail.productId !== this.id) return;
          this.open(event.button);
        });
      }
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      this._previouslyFocused?.focus();
      window.removeTrapFocus();
    }

    open(triggerElement) {
      this._previouslyFocused = triggerElement || document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      this.querySelector('[data-product-details-modal-close]')?.focus();
      window.trapFocus(this);
    }
  }

  window.customElements.define('product-details-modal', ProductDetailsModal);
}

if (!window.customElements.get('view-product-details-button')) {
  class ViewProductDetailsButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');

      if (this.button) {
        this.button.addEventListener('click', () => this.openModal());
      }
    }

    openModal() {
      document.dispatchEvent(
        new CustomEvent('openProductDetailsModal', {
          detail: { button: this.button, productId: this.getAttribute('data-product-id') },
          bubbles: true,
        })
      );
    }
  }

  window.customElements.define('view-product-details-button', ViewProductDetailsButton);
}
